// import { createContext, useContext, useEffect, useState } from "react";
// import { io } from "socket.io-client";
// import { apiurl } from "./config";

// const SocketContext = createContext();

// // Create socket instance (backend URL should match your server)
// const socket = io(apiurl, {
//   transports: ["websocket"],
//   reconnection: true,
//   reconnectionAttempts: 5,
//   reconnectionDelay: 2000,
// });

// export const SocketProvider = ({ children }) => {
//   const [isConnected, setIsConnected] = useState(socket.connected);
//   const [messages, setMessages] = useState([]);
//   const [typingStatus, setTypingStatus] = useState("");

//   useEffect(() => {
//     // Handle successful connection
//     socket.on("connect", () => {
//       setIsConnected(true);
//       console.log("Connected to server:", socket.id);
//     });

//     // Handle disconnection
//     socket.on("disconnect", () => {
//       setIsConnected(false);
//       console.log("Disconnected from server");
//     });

//     // Listen for incoming messages
//     socket.on("message", (message) => {
//       setMessages((prev) => [...prev, message]);
//     });

//     // Listen for typing status
//     socket.on("typing", (user) => {
//       setTypingStatus(`${user} is typing...`);
//       setTimeout(() => setTypingStatus(""), 2000);
//     });

//     return () => {
//       socket.off("connect");
//       socket.off("disconnect");
//       socket.off("message");
//       socket.off("typing");
//     };
//   }, []);

//   // Function to send messages
//   const sendMessage = (messageData) => {
//     socket.emit("message", messageData);
//   };

//   // Function to emit typing event
//   const sendTypingStatus = (user) => {
//     socket.emit("typing", user);
//   };

//   return (
//     <SocketContext.Provider value={{ isConnected, messages, sendMessage, sendTypingStatus, typingStatus }}>
//       {children}
//     </SocketContext.Provider>
//   );
// };

// // Custom hook for using socket context
// export const useSocket = () => useContext(SocketContext);

import { createContext, useContext, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { apiurl } from "./config";

const SocketContext = createContext();

// Create socket connection (same backend as your Express server)
const socket = io(apiurl, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 2000,
});

export const SocketProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(socket.connected);
  const [messages, setMessages] = useState({});
  const [typingStatus, setTypingStatus] = useState({});

  useEffect(() => {
    // --- Connection handlers ---
    socket.on("connect", () => {
      setIsConnected(true);
      console.log("✅ Connected:", socket.id);
    });

    socket.on("disconnect", () => {
      setIsConnected(false);
      console.log("❌ Disconnected");
    });

    // --- Message event ---
    socket.on("message", ({ roomId, message }) => {
      setMessages((prev) => ({
        ...prev,
        [roomId]: [...(prev[roomId] || []), message],
      }));
    });

    // --- Typing event ---
    socket.on("typing", ({ roomId, user }) => {
      setTypingStatus((prev) => ({ ...prev, [roomId]: `${user} is typing...` }));
      setTimeout(() => {
        setTypingStatus((prev) => ({ ...prev, [roomId]: "" }));
      }, 2000);
    });

    return () => {
      socket.off("connect");
      socket.off("disconnect");
      socket.off("message");
      socket.off("typing");
    };
  }, []);

  // --- Join a room ---
  const joinRoom = (roomId) => {
    if (roomId) {
      socket.emit("join_room", roomId);
      console.log(`🟢 Joined room: ${roomId}`);
    }
  };

  // --- Send a message to a specific room ---
  const sendMessage = (roomId, messageData) => {
    if (!roomId || !messageData) return;
    socket.emit("message", { roomId, message: messageData });
  };

  // --- Send typing status for a room ---
  const sendTypingStatus = (roomId, user) => {
    socket.emit("typing", { roomId, user });
  };

  return (
    <SocketContext.Provider
      value={{
        socket,
        isConnected,
        joinRoom,
        sendMessage,
        sendTypingStatus,
        messages,
        typingStatus,
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

// Hook for using socket context
export const useSocket = () => useContext(SocketContext);